import { render, staticRenderFns } from "./singleChoice.vue?vue&type=template&id=95f10bce&scoped=true&"
import script from "./singleChoice.vue?vue&type=script&lang=js&"
export * from "./singleChoice.vue?vue&type=script&lang=js&"
import style0 from "./singleChoice.vue?vue&type=style&index=0&id=95f10bce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f10bce",
  null
  
)

export default component.exports